import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import type { IBusinesPortalLogin } from '@app/core/interfaces/IBusinessPortal';
import type { ApiResponse } from '@shared';
import { CookieService } from 'ngx-cookie-service';
import { Observable, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class BusinessAuthService {
  private loginBy = new BehaviorSubject<'email' | 'mobile'>('email');
  public loginMethod = this.loginBy.asObservable();
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
  ) {}

  login(data: IBusinesPortalLogin): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/business-portal/login', data);
  }

  verifyOTP(data: { otp: string; businessId: string }): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/business-portal/verify-otp', data);
  }

  setLoginMethod(val: 'email' | 'mobile') {
    this.loginBy.next(val);
  }

  logout() {
    this.cookieService.delete('businessportalRefreshToken', '/');
    this.cookieService.delete('businessportalAccessToken', '/');
    this.router.navigate(['/business-portal/login']);
  }

  termsAndCondition(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/business-portal/terms-and-condition');
  }
}
